import { attr, css, customElement, FoundationElement, html } from '@genesislcap/web-core';

@customElement({
  name: 'deal-series-action-icon',
  template: html`
    <rapid-icon name="${(x) => x.name}"></rapid-icon>
  `,
  styles: css`
    :host {
      display: flex;
      height: 28px;
      width: 28px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 3px;
    }
    :host(:hover) {
      background: rgba(255, 255, 255, 0.2);
    }
  `,
})
export class DealSeriesActionIcon extends FoundationElement {
  @attr name: string;
}
